var mainEl = 'header.header-mylt';
var offCanvasWrap = mainEl + ' > ltnav-offcanvas-wrap';

export default {
	mainElement: 'header.header',
	clubHeaderElement: '#clubLocator',
	primaryNavContainer: '.js-ltnav-primary',
	mobileBrandContainer: '.header-brand-mobile',
	isCurrentClassName: 'active',
	locateAClubEl: '.js-club-locator',
	locateAClubOmnibox: '.js-club-locator-omnibox',
	accountNav: '#utilAccount',
	profileVisible: '.js-profile',
	clubAccessVisible: '.js-club-access',
	ltBucksValue: '.js-ltbucks-value',
	anonymousVisible: '.js-anonymous',
	logoutLink: '.js-logout-link',
	ltAccountToggle: '.ltnav-account-toggle',
	loginLabel: '.js-login-label',
	ltNavClubName: '.js-ltnav-clubname',
	viewAccountDivider: '.view-account-divider'
};
